import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { BehaviorSubject, Observable, of } from "rxjs";
import { tap, catchError } from "rxjs/operators";
import { GlobalVariable } from "app/global/global";
import {
  CONDICIONES_POR_CARA,
  CONDICIONES_POR_DIENTE,
  CondicionConfig,
} from "app/shared/odontograma/catalogo-condiciones";

interface EntradaRemota {
  codigo?: string;
  nombre: string;
  color: string;
  oculto?: boolean;
  sistema?: boolean;
}

interface ConfigRemota {
  porCara: Record<string, EntradaRemota>;
  porDiente: Record<string, EntradaRemota>;
}

@Injectable({ providedIn: "root" })
export class OdontogramaConfigService {
  private url = GlobalVariable.BASE_API_URL + "api/odontograma-config";

  private _cara = new BehaviorSubject<CondicionConfig[]>(CONDICIONES_POR_CARA);
  private _diente = new BehaviorSubject<CondicionConfig[]>(CONDICIONES_POR_DIENTE);

  cara$ = this._cara.asObservable();
  diente$ = this._diente.asObservable();

  constructor(private http: HttpClient) {}

  get cara(): CondicionConfig[] {
    return this._cara.value;
  }
  get diente(): CondicionConfig[] {
    return this._diente.value;
  }

  cargar(): Observable<ConfigRemota | null> {
    return this.http.get<ConfigRemota>(this.url).pipe(
      tap((cfg) => {
        if (cfg?.porCara) this._cara.next(this.aLista(cfg.porCara));
        if (cfg?.porDiente) this._diente.next(this.aLista(cfg.porDiente));
      }),
      catchError(() => of(null)),
    );
  }

  guardar(payload: {
    porCara: Record<string, { nombre: string; color: string; oculto: boolean }>;
    porDiente: Record<string, { nombre: string; color: string; oculto: boolean }>;
  }): Observable<any> {
    return this.http.put(this.url, payload).pipe(
      tap(() => this.cargar().subscribe()),
    );
  }

  private aLista(remoto: Record<string, EntradaRemota>): CondicionConfig[] {
    return Object.entries(remoto).map(([codigo, v]) => ({
      codigo,
      label: v.nombre,
      color: v.color,
      oculto: !!v.oculto,
      sistema: !!v.sistema,
    }));
  }
}
